import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnDark";
import MainFeature1 from "components/features/TwoColWithButton.js";
import Features from "components/features/ThreeColSimple.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";
import TwoColumnWithVideo from "components/hero/TwoColumnWithVideo"
// import FrontendImage1 from "../../images/frontend-tech1.png";
// import FrontendImage2 from "../../images/frontend-tech2.png";

import ContactUs from "pages/ContactUs";
import TwoColContactUsWithIllustrationFullForm from "components/forms/TwoColContactUsWithIllustrationFullForm";
import GetStarted from "components/cta/GetStarted";

import Frontend from "../../images/frontend1.png"
import ReactIcon from "../../images/icons8-react-50.png"
import Vue from "../../images/icons8-vue-js.svg"
import Angular from "../../images/icons8-angularjs.svg"

const Subheading = tw.span`uppercase tracking-wider text-sm`;

export default ({ roundedHeaderButton }) => {
  return (
    <AnimationRevealPage>
      {/* Hero Section */}
      <TwoColumnWithVideo
        heading="Frontend Technologies for Building Modern Web Apps"
        buttonRounded={false}
        primaryButtonText="Request Free Consultation"
        primaryButtonUrl="https://calendly.com/solutions-tbnw/30min?month=2024-11"
        description="Our team specializes in frontend technologies like React, Angular, Vue.js, HTML5, CSS3, and JavaScript to build dynamic, user-friendly web applications. We create responsive, scalable, and high-performing web solutions tailored to your business needs."
        imageSrc={Frontend}
      />

      {/* Main Feature Section */}
      <MainFeature1
        subheading={<Subheading>Our Expertise</Subheading>}
        heading="Ready to Elevate Your Web Development?"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl="/contactus"
        description="We leverage modern frontend technologies to create exceptional user experiences. Whether you're building a new website or revamping an existing one, our expert developers can help you choose the right tools and frameworks for your project."
    
        textOnLeft={false}
      />

      {/* Feature Section */}
      <Features
        heading="Frontend Technology Stack"
        description="Our frontend team is proficient in the latest web technologies. We work with the best frameworks and libraries to deliver highly interactive and scalable web applications."
        cards={[
          {
            imageSrc: ReactIcon,
            title: "React.js",
            description: "Build fast, interactive user interfaces with React, the most popular JavaScript library for building UIs."
          },
          {
            imageSrc: Vue,
            title: "Vue.js",
            description: "A progressive framework for building modern web applications with a focus on simplicity."
          },
          {
           imageSrc: Angular,
            title: "Angular",
            description: "A TypeScript-based framework for building robust web applications with a component-based architecture."
          }
        ]}
      />

      {/* Get Started Section */}
      <GetStarted />

      {/* Contact Us Section */}
      <TwoColContactUsWithIllustrationFullForm />
      
      {/* Footer */}
      <Footer />
    </AnimationRevealPage>
  );
};
